module.exports = __webpack_public_path__ + "img/monitor.e3872b3f.svg";